"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFICATION_TYPE = void 0;
exports.NOTIFICATION_TYPE = {
    SCAN_REMINDER: 'scan_reminder',
    SCAN_COMPLETION: 'scan_completion',
    REPORT_COMPLETION: 'report_completion',
    WEEKLY_REPORT_SKIPPED: 'weekly_report_skipped',
    WEEKLY_REPORT_READY: 'weekly_report_ready',
    FIRST_REPORT_READY: 'first_report_ready',
};
//# sourceMappingURL=notifications.js.map